import React, { useState } from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';

import { LoadingOutlined, FileImageOutlined } from '@ant-design/icons';

import './styles.less';

export const Image = ( props ) => {
    const [ isLoading, setLoading ] = useState( true );
    const [ hasError, setError ] = useState( false );

    const overlayClasses = classnames( [
        'image-overlay',
        { 'hidden': !( isLoading || props.loading || props.missing ) },
    ] );

    const containerClasses = classnames( [
        'image-container',
        { [ props.className ]: Boolean( props.className ) },
    ] );

    return (
        <div className={ containerClasses } onClick={ props.onClick } style={ props.style }>
            { /* The image overlay to display when the image is loading. */ }
            <div className={ overlayClasses }>
                <div className="image-overlay-color" />

                { /* The icon to display only when loading. */ }
                { ( isLoading || props.loading ) &&
                    <LoadingOutlined className="overlay-icon" />
                }

                { /* The icon to display only when considered missing. */ }
                { !( isLoading || props.loading ) && ( props.missing || hasError ) &&
                    <FileImageOutlined className="overlay-icon" />
                }
            </div>

            { /* The actual image to display once loading is complete. */ }
            <div className="image" style={ {
                opacity: ( isLoading || props.loading || props.missing || hasError ) ? '0%' : '100%',
            } }>
                { Boolean( props.overlayColor ) &&
                    <div className="image-overlay-color" style={ {
                        backgroundColor: props.overlayColor,
                        opacity: props.overlayOpacity,
                    } } />
                }
                <img 
                    key={ props.src }
                    src={ props.src }
                    onLoad={ () => setLoading( false ) }
                    onError={ () => setError( true ) }
                    alt={ props.alt }
                />
            </div>
        </div>
    );
};

Image.defaultProps = {
    loading: false,
    missing: false,
    overlayColor: undefined,
    overlayOpacity: 0.1,
};

Image.propTypes = {
    className: PropTypes.string,
    style: PropTypes.object,
    src: PropTypes.string,
    alt: PropTypes.string,
    onClick: PropTypes.func,
    loading: PropTypes.bool,
    missing: PropTypes.bool,
    overlayColor: PropTypes.string,
    overlayOpacity: PropTypes.oneOfType( [ PropTypes.number, PropTypes.string ] ),
};
